import React from "react"
import styled from "styled-components"
import { View } from "./"
import { space } from "styled-system"

const isRetina = () => {
  var mediaQuery =
    "(-webkit-min-device-pixel-ratio: 1.5),\
          (min--moz-device-pixel-ratio: 1.5),\
          (-o-min-device-pixel-ratio: 3/2),\
          (min-resolution: 1.5dppx)"
  if (window.devicePixelRatio > 1) return true
  if (window.matchMedia && window.matchMedia(mediaQuery).matches) return true
  return false
}

/*
  border-bottom: 1px solid currentColor;
  ${isRetina() ? `border-width: 0.5px` : null}
*/

export default styled(View).attrs(() => ({ as: "hr", color: "border" }))`
  position: relative;
  overflow: visible;
  border: 0;
  border-bottom: 1px solid transparent;
  background: none;
  ${({ thick }) =>
    thick
      ? `border-bottom: 2px solid currentCOlor;`
      : `
    &:after {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border-bottom: 1px solid currentColor;
    transform: scale(0.5);
  }
  `}
  ${space};
`
